const initialState = {
    user: '',
    userFullName: '',

    noData: false,

    bidsData: {},
    fetching: false,
    fetched: false,
    error: null,

    valuesData: {},
    valuesFetching: false,
    valuesFetched: false,
    valuesError: null,

    percent_complete: 0,
    complete_export: false   
}

export function bidsReducer(state = initialState, action) {

    switch (action.type) {

        case "FETCH_BIDS_LIST_TOKEN":
        case "FETCH_BIDS_LIST": {
            return { ...state, fetching: true, fetched: false, error: null }
        }
        case "FETCH_BIDS_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }
        case "FETCH_BIDS_LIST_FULFILLED": {
            let bidStatusMap = {}
            let totalActiveBids = 0
            let totalArchiveBids = 0

            action.payload.data.statusFilters = []
            action.payload.data.bidsFilters =[]

            action.payload.data.activeBids = {}
            action.payload.data.activeBidsFilters = []

            action.payload.data.archiveBids = {}
            action.payload.data.archiveBidsFilters = []

            action.payload.data.allBidsFilters = []

            action.payload.data.bidStatuses.map((bidstat) => {
                if (bidstat.isActive) {
                    bidStatusMap[bidstat.name] = bidstat.displayAsActive

                    if (bidstat.displayAsActive)
                        action.payload.data.activeBids[bidstat.name] = 0
                    else
                        action.payload.data.archiveBids[bidstat.name] = 0
                }
            })

            action.payload.data.bids.map((bid) => {
                var date = new Date(bid.estimatedStartDate);
                bid.estimatedStartDateDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();

                date = new Date(bid.lastUpdatedAt);
                bid.lastUpdatedAtDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();

                date = new Date(bid.submissionDate);
                bid.submissionDateDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();

                if (bidStatusMap[bid.bidStatusName]) {
                    totalActiveBids++
                    action.payload.data.activeBids[bid.bidStatusName]++
                }
                else {
                    totalArchiveBids++
                    action.payload.data.archiveBids[bid.bidStatusName]++
                }

                var numUnits = bid.numberOfUnits;
                bid.numDispUnits = numUnits.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            });

            action.payload.data.bids.sort((a, b) => {
                var d1 = new Date(a.submissionDate)
                var d2 = new Date(b.submissionDate)

                if (d1 > d2)
                    return -1
                else if (d1 < d2)
                    return 1
                else
                    return 0
            })

            action.payload.data.statusFilters.push({ filter: 'Active', count: totalActiveBids })
            action.payload.data.statusFilters.push({ filter: 'Archive', count: totalArchiveBids })

            for (let [key, value] of Object.entries(action.payload.data.activeBids)) {
                action.payload.data.allBidsFilters.push({ filter: key, count: value })
                action.payload.data.activeBidsFilters.push({ filter: key, count: value })
            }

            for (let [key, value] of Object.entries(action.payload.data.archiveBids)) {
                action.payload.data.allBidsFilters.push({ filter: key, count: value })
                action.payload.data.archiveBidsFilters.push({ filter: key, count: value })
            }

            action.payload.data.activeBidsFilters.forEach((filt) => {
                action.payload.data.bidsFilters.push(filt)
            })

            return { ...state, fetching: false, fetched: true, noData: action.payload.data.bids.length == 0, bidsData: action.payload.data }
        }
        case "FETCH_BID_ERROR": {
            return { ...state, error: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }

        case "SET_BIDS_FILTERS": {
            var bidsData = Object.assign({}, state.bidsData)

            bidsData.bidsFilters = []

            if (action.payload.data.includes("Active") && action.payload.data.includes("Archive"))
                bidsData.allBidsFilters.forEach((filt) => { bidsData.bidsFilters.push(filt)})
            else if (action.payload.data.includes('Active'))
                bidsData.activeBidsFilters.forEach((filt) => { bidsData.bidsFilters.push(filt) })
            else if (action.payload.data.includes('Archive'))
                bidsData.archiveBidsFilters.forEach((filt) => { bidsData.bidsFilters.push(filt) })

            return { ...state, bidsData: bidsData }
        }

        case "FETCH_BIDS_VALUES_TOKEN":
        case "FETCH_BIDS_VALUES": {
            return { ...state, valuesFetching: true, valuesFetched: false, valuesError: null }
        }
        case "FETCH_BIDS_VALUES_REJECTED": {
            return { ...state, valuesFetching: false, valuesError: action.payload }
        }
        case "FETCH_BIDS_VALUES_FULFILLED": {
            return { ...state, valuesFetching: false, valuesFetched: true, valuesData: action.payload.data }
        }
        case "FETCH_BIDS_VALUES_ERROR": {
            return { ...state, valuesError: null }
        }

        case "EXPORT_EXCEL_BIDS": {
            return { ...state, fetching: false, fetched: true, filter: action.payload.data }
        }

        case "PERCENTAGE_COMPLETE_BIDS": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }
        case "EXPORT_START_BIDS": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data }
        }
        case "FINISH_EXPORT_BIDS": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }
        case "COMPLETE_EXPORT_BIDS": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data }
        }    

        case "SORT_BID": {
            let bidsDataSorted = Object.assign({}, state.bidsData)

            switch (action.payload.sort) {
                case "SUBMIT": {
                    bidsDataSorted.bids.sort(function (a, b) {
                        var d1 = new Date(a.submissionDate)
                        var d2 = new Date(b.submissionDate)

                        if (d1 < d2)
                            return action.payload.order =="Ascending" ? -1 : 1
                        else if (d1 > d2)
                            return action.payload.order == "Ascending" ? 1 : -1
                        else
                            return 0
                    })

                    return { ...state, bidsData: bidsDataSorted }
                }
                case "SALES": {
                    bidsDataSorted.bids.sort(function (a, b) {
                        if (a.salesPerson.toLowerCase() < b.salesPerson.toLowerCase())
                            return action.payload.order == "Ascending" ? -1 : 1
                        else if (a.salesPerson.toLowerCase() > b.salesPerson.toLowerCase())
                            return action.payload.order == "Ascending" ? 1 : -1
                        else
                            return 0
                    })

                    return { ...state, bidsData: bidsDataSorted }
                }
                case "COMPANY": {
                    bidsDataSorted.bids.sort(function (a, b) {
                        if (a.companyName.toLowerCase() < b.companyName.toLowerCase())
                            return action.payload.order == "Ascending" ? -1 : 1
                        else if (a.companyName.toLowerCase() > b.companyName.toLowerCase())
                            return action.payload.order == "Ascending" ? 1 : -1
                        else
                            return 0
                    })

                    return { ...state, bidsData: bidsDataSorted }
                }
                case "PROJECT": {
                    bidsDataSorted.bids.sort(function (a, b) {
                        if (a.projectName.toLowerCase() < b.projectName.toLowerCase())
                            return action.payload.order == "Ascending" ? -1 : 1
                        else if (a.projectName.toLowerCase() > b.projectName.toLowerCase())
                            return action.payload.order == "Ascending" ? 1 : -1
                        else
                            return 0
                    })

                    return { ...state, bidsData: bidsDataSorted }
                }
                case "UNITS": {
                    bidsDataSorted.bids.sort(function (a, b) {
                        if (a.numberOfUnits < b.numberOfUnits)
                            return action.payload.order == "Ascending" ? -1 : 1
                        else if (a.numberOfUnits > b.numberOfUnits)
                            return action.payload.order == "Ascending" ? 1 : -1
                        else
                            return 0
                    })

                    return { ...state, bidsData: bidsDataSorted }
                }
                case "TYPE": {
                    bidsDataSorted.bids.sort(function (a, b) {
                        if (state.valuesData.unitTypes[a.unitTypeId].name.toLowerCase() < state.valuesData.unitTypes[b.unitTypeId].name.toLowerCase())
                            return action.payload.order == "Ascending" ? -1 : 1
                        else if (state.valuesData.unitTypes[a.unitTypeId].name.toLowerCase() > state.valuesData.unitTypes[b.unitTypeId].name.toLowerCase())
                            return action.payload.order == "Ascending" ? 1 : -1
                        else
                            return 0
                    })

                    return { ...state, bidsData: bidsDataSorted }
                }
                case "STATE": {
                    bidsDataSorted.bids.sort(function (a, b) {
                        if (state.valuesData.projectStates[a.projectStateId].stateId < state.valuesData.projectStates[b.projectStateId].stateId)
                            return action.payload.order == "Ascending" ? -1 : 1
                        else if (state.valuesData.projectStates[a.projectStateId].stateId > state.valuesData.projectStates[b.projectStateId].stateId)
                            return action.payload.order == "Ascending" ? 1 : -1
                        else
                            return 0
                    })

                    return { ...state, bidsData: bidsDataSorted }
                }
                case "START": {
                    bidsDataSorted.bids.sort(function (a, b) {
                        var d1 = new Date(a.estimatedStartDate)
                        var d2 = new Date(b.estimatedStartDate)

                        if (d1 < d2)
                            return action.payload.order == "Ascending" ? -1 : 1
                        else if (d1 > d2)
                            return action.payload.order == "Ascending" ? 1 : -1
                        else
                            return 0
                    })

                    return { ...state, bidsData: bidsDataSorted }
                }
                case "BID": {
                    bidsDataSorted.bids.sort(function (a, b) {
                        if (a.bidAmount < b.bidAmount)
                            return action.payload.order == "Ascending" ? -1 : 1
                        else if (a.bidAmount > b.bidAmount)
                            return action.payload.order == "Ascending" ? 1 : -1
                        else
                            return 0
                    })

                    return { ...state, bidsData: bidsDataSorted }
                }
                case "UPDATED": {
                    bidsDataSorted.bids.sort(function (a, b) {
                        var d1 = new Date(a.lastUpdatedAt)
                        var d2 = new Date(b.lastUpdatedAt)

                        if (d1 < d2)
                            return action.payload.order == "Ascending" ? -1 : 1
                        else if (d1 > d2)
                            return action.payload.order == "Ascending" ? 1 : -1
                        else
                            return 0
                    })

                    return { ...state, bidsData: bidsDataSorted }
                }
                case "STATUS": {
                    bidsDataSorted.bids.sort(function (a, b) {
                        if (state.valuesData.bidStatuses[a.bidStatusId].name.toLowerCase() < state.valuesData.bidStatuses[b.bidStatusId].name.toLowerCase())
                            return action.payload.order == "Ascending" ? -1 : 1
                        else if (state.valuesData.bidStatuses[a.bidStatusId].name.toLowerCase() > state.valuesData.bidStatuses[b.bidStatusId].name.toLowerCase())
                            return action.payload.order == "Ascending" ? 1 : -1
                        else
                            return 0
                    })

                    return { ...state, bidsData: bidsDataSorted }
                }

                default:
                    return state
            }
        }

        default:
            return state
    }
}
